/// <amd-module name="Feed/Common/Constants/Constants" />
import { CustomSet } from "Feed/Common/Types/CustomSet";

/* tslint:disable:max-classes-per-file max-file-line-count*/
/**
 * Represents the allowed actions in the URL.
 */
export class HubActionStrings {
    public static CreateFeed: string = "createfeed";
    public static ViewFeed: string = "feed";
    public static ViewPackage: string = "package";
    public static Settings: string = "settings";
    public static RecycleBin: string = "recyclebin";
    public static RecycleBinPackage: string = "recyclebinpackage";
    public static PackageDependencySelected: string = "dependency";
    public static Connect: string = "connect";
}

export let SupportedHubActionStrings = new CustomSet<string>();
SupportedHubActionStrings.add(HubActionStrings.CreateFeed);
SupportedHubActionStrings.add(HubActionStrings.ViewFeed);
SupportedHubActionStrings.add(HubActionStrings.ViewPackage);
SupportedHubActionStrings.add(HubActionStrings.Settings);
SupportedHubActionStrings.add(HubActionStrings.RecycleBin);
SupportedHubActionStrings.add(HubActionStrings.RecycleBinPackage);
SupportedHubActionStrings.add(HubActionStrings.PackageDependencySelected);
SupportedHubActionStrings.add(HubActionStrings.Connect);

export let SupportedAnonymousHubActionStrings = new CustomSet<string>();
SupportedAnonymousHubActionStrings.add(HubActionStrings.Connect);
SupportedAnonymousHubActionStrings.add(HubActionStrings.ViewFeed);
SupportedAnonymousHubActionStrings.add(HubActionStrings.ViewPackage);
SupportedAnonymousHubActionStrings.add(HubActionStrings.PackageDependencySelected);

/**
 * Common constants.
 */
export class CommonConstants {
    public static FeatureArea: string = "Packaging";
    public static MaxFeedNameLength: number = 64;
}

/**
 * Perfomance scenario constants.
 */
export class PerfScenarios {
    public static Area = CommonConstants.FeatureArea;
    public static BreadCrumbSelected = "Packaging.Feed.BreadCrumbSelected";
    public static ConnectFeed = "Packaging.Feed.ConnectToFeed";
    public static CreateFeed = "Packaging.Feed.CreateFeed";
    public static CreateProjectScopedFeed = "Packaging.Feed.CreateProjectScopedFeed";
    public static CreatePublicFeed = "Packaging.Feed.CreatePublicFeed";
    public static DeleteFeed = "Packaging.Feed.DeleteFeed";
    public static EditFeedSave = "Packaging.Feed.EditFeed.Save";
    public static FeedPermananentDeleted = "Packaging.Feed.FeedPermanentDeleted";
    public static FeedSelected = "Packaging.Feed.FeedSelected";
    public static FeedRecycleBinSelected = "Packaging.Feed.RecycleBinSelected";
    public static FeedRestored = "Packaging.Feed.FeedRestored";
    public static FeedUpdated = "Packaging.Feed.FeedUpdated";
    public static FeedViewSelected = "Packaging.Feed.FeedViewSelected";
    public static FilterPackages = "Packaging.Feed.FilterPackages";
    public static GlobalPermissionsLoad = "Packaging.Feed.GlobalPermissions.Load";
    public static GlobalPermissionsSave = "Packaging.Feed.GlobalPermissions.Save";
    public static PackagesPageLoad = "Packaging.Feed.PackagesPageLoad";
    public static RecycleBinPackagesPageLoad = "Packaging.Feed.RecycleBinPackagesPageLoad";
    public static PermissionsLoad = "Packaging.Feed.EditPermissions.Load";
    public static PermissionsSave = "Packaging.Feed.EditPermissions.Save";
    public static ReleaseViewsSave = "Packaging.Feed.ReleaseViews.Save";
    public static UpstreamSourceUpdated = "Package.Feed.UpstreamSourceUpdated";
    public static CustomPublicUpstreamSourceAdded = "Package.Feed.CustomPublicUpstreamSourceAdded";

    public static MultiplePackageVersionsDeleted = "Package.Feed.PackagesMultiDeleted";
    public static MultiplePackageVersionsDeprecated = "Package.Feed.PackagesMultiDeprecated";
    public static MultiplePackageVersionsListedUnlisted = "Package.Feed.PackagesMultiListedUnlisted";
    public static MultiplePackageVersionsRestoredToFeed = "Package.Feed.PackagesRestoredToFeed";
    public static MultiplePackageVersionsPermanentDeleted = "Package.Feed.PackagesPermanentDeleted";
    public static EmptyRecycleBin = "Package.Feed.EmptyRecycleBin";
    public static PackagePromoted = "Packaging.Feed.PackagePromoted";
    public static PackagesPromoted = "Packaging.Feed.PackagesMultiPromoted";
    public static PackageListUpdated = "Packaging.Feed.PackageListUpdated";
    public static PackageSelected = "Packaging.Package.PackageSelected";
    public static PackageDependencySelected = "Packaging.Package.PackageDependencySelected";
    public static RecycleBinPackageSelected = "Packaging.Package.RecycleBinPackageSelected";
    public static PackageVersionDeleted = "Packaging.Package.PackageVersionDeleted";
    public static PackageVersionModified = "Packaging.Package.VersionModified";
    public static PackageVersionSelected = "Packaging.Package.VersionSelected";
    public static PackageVersionSelectedNew = "Packaging.Package.VersionSelectedNew";
    public static RecycleBinPackageVersionSelected = "Packaging.Package.RecycleBinPackageVersionSelected";
    public static PackageVersionsPivotSelected = "Packaging.Package.VersionsPivotSelected";
    public static RecycleBinPackageVersionsPivotSelected = "Packaging.Package.RecycleBinPackageVersionsPivotSelected";
    public static RecycleBinPackageVersionRestore = "Packaging.Package.RecycleBinPackageVersionRestore";
    public static RecycleBinPackageVersionPermanentDelete = "Packaging.Package.RecycleBinPackageVersionPermanentDelete";

    /**
     * Tracks page load
     */
    public static PageLoad = "Packaging.Hub.Load";
    public static PageLoadUnlicensed = "Packaging.Hub.LoadUnlicensed";
    /**
     * Tracks hub load
     */
    public static Initialize = "Packaging.Hub.Initialize";
}

export class HubScenarioSplits {
    public static INITIALIZING = "Packaging.Hub.Initiailizing";
    public static STORESCREATED = "Packaging.Hub.StoreCreated";
    public static RENDERCOMPLETE = "Packaging.Hub.RenderComplete";
}

export class EmptyRecycleBinScenarioSplits {
    public static GETPACKAGESBATCH = "Packaging.RecycleBin.GetPackagesBatchComplete";
    public static SENDBATCHPERMANENTDELETE = "Packaging.RecycleBin.SendBatchPermanentDeleteComplete";
    public static EMPTYRECYCLEBINCOMPLETE = "Packaging.RecycleBin.EmptyRecycleBinComplete";
}

export class CiConstants {
    public static Area = CommonConstants.FeatureArea;
    public static AddFeedDescriptionLinkClicked = "AddFeedDescriptionLinkClicked";
    public static BuildMoreInfoLink = "BuildMoreInfoLink";
    public static CreateFeedPageClosed = "CreateFeedPageClosed";
    public static CreateFeedPageError = "CreateFeedPageError";
    public static CreateFeedPageOpened = "CreateFeedPageOpened";
    public static ConnectToFeed = "ConnectToFeed";
    public static ConnectToFeedOpened = "Opened";
    public static ConnectToFeedTabChanged = "TabChanged";
    public static ConnectToFeedCredentialsGenerated = "CredentialsGenerated";
    public static CopyCommand = "CopyCommand";
    public static CopyCommandAddSource = "AddSource";
    public static CopyCommandAuthToken = "AuthToken";
    public static CopyCommandCreatePackage = "CreatePackage";
    public static CopyCommandFeedURL = "FeedURL";
    public static CopyCommandInstall = "Install";
    public static CopyCommandInternalUpstreamLocator = "InternalUpstreamLocator";
    public static CopyCommandPush = "Push";
    public static CopyCommandBadgeMarkdown = "CopyBadgeMarkdown";
    public static CopyCommandBadgeImage = "CopyBadgeImage";
    public static DeletedFeedPanel = "DeletedFeedPanel";
    public static EditFeedDialog = "EditFeedDialog";
    public static EditFeedDialogOpened = "EditFeedDialogOpened";
    public static EditFeedDialogClosed = "EditFeedDialogClosed";
    public static EditFeedDialogGeneralTabOpened = "EditFeedDialogGeneralTabOpened";
    public static EditFeedDialogPermissionTabOpened = "EditFeedDialogPermissionTabOpened";
    public static EditFeedDialogReleaseViewsTabOpened = "EditFeedDialogReleaseViewsTabOpened";
    public static EditFeedDialogRetentionPoliciesTabOpened = "EditFeedDialogRetentionPoliciesTabOpened";
    public static EditFeedDialogUpstreamSourcesTabOpened = "EditFeedDialogUpstreamSourcesTabOpened";
    public static EditFeedDialogDeletedPackagesTabOpened = "EditFeedDialogDeletedPackagesTabOpened";
    public static EmptyFeedLearnMoreLinkClicked = "EmptyFeedLearnMoreLinkClicked";
    public static EmptyFeedPanel = "EmptyFeedPanel";
    public static ExternalLink = "ExternalLink";
    public static FeedBreadCrumbClicked = "FeedBreadCrumbClicked";
    public static RecycleBinButtonClicked = "RecycleBinButtonClicked";
    public static RecycleBinBreadCrumbClicked = "RecycleBinBreadCrumbClicked";
    public static RecycleBinOpened = "RecycleBinOpened";
    public static FeedDeleted = "FeedDeleted";
    public static FeedDescriptionUpdated = "FeedDescriptionUpdated";
    public static FeedNameUpdated = "FeedNameUpdated";
    public static FeedPermanentDeleted = "FeedPermanentDeleted";
    public static FeedPermissionsUpdated = "FeedPermissionsUpdated";
    public static FeedSelected = "FeedSelected";
    public static FeedSettingsOpened = "FeedSettingsOpened";
    public static FeedUpdated = "FeedUpdated";
    public static FeedUpstreamEnabledUpdated = "FeedUpstreamEnabledUpdated";
    public static FeedViewAdded = "FeedViewAdded";
    public static FeedViewRemoved = "FeedViewRemoved";
    public static FeedViewRenamed = "FeedViewRenamed";
    public static FeedViewSelected = "FeedViewSelected";
    public static FeedViewsUpdated = "FeedViewsUpdated";
    public static GlobalSettingsPermissionsChanged = "GlobalSettingsPermissionsChanged";
    public static GlobalSettingsPermissionsError = "GlobalSettingsPermissionsError";
    public static GlobalSettingsDialogOpened = "GlobalSettingsDialogOpened";
    public static MultiplePackageVersionsDeleted = "PackagesMultiDeleted";
    public static MultiplePackageVersionsDeprecated = "PackagesMultiDeprecated";
    public static MultiplePackageVersionsListedUnlisted = "PackagesMultiListedUnlisted";
    public static MultiplePackageVersionsRestoredToFeed = "PackagesRestored";
    public static MultiplePackageVersionsPermanentDeleted = "PackagesPermanentDeleted";
    public static BatchRequestFailed = "BatchRequestFailed";
    public static EmptyRecycleBin = "EmptyRecycleBin";
    public static MultiPromotePanelOpened = "MultiPromotePanelOpened";
    public static NewFeedCreated = "NewFeedCreated";
    public static NewFeedCreateError = "NewFeedCreateError";
    public static PackageDevelopment = "PackageDeveopment";
    public static PackageDirectlyLoaded = "PackageDirectlyLoaded";
    public static PackagePromoted = "PackagePromoted";
    public static PackagesPromoted = "PackagesMultiPromoted";
    public static PackageListUpdated = "PackageListUpdated";
    public static PackageLoadError = "PackageLoadError";
    public static PackageSelected = "PackageSelected";
    public static PackageDependencySelected = "PackageDependencySelected";
    public static PackageBadgePanelOpened = "PackageBadgePanelOpened";
    public static RecycleBinPackageSelected = "RecycleBinPackageSelected";
    public static PackageUpstreamLocatorCommand = "PackageUpstreamLocatorCommand";
    public static PackageVersionDeleted = "PackageVersionDeleted";
    public static PackageVersionModified = "PackageVersionModified";
    public static PackageVersionSelected = "PackageVersionSelected";
    public static PackageVersionSelectedNew = "PackageVersionSelectedNew";
    public static RecycleBinPackageVersionSelected = "RecycleBinPackageVersionSelected";
    public static PackagesFiltered = "PackagesFiltered";
    public static PackagesPageRequested = "PackagesPageRequested";
    public static PackageVersionInstallCommandCopied = "PackageVersionInstallCommandCopied";
    public static PackageVersionLinkCopied = "PackageVersionLinkCopied";
    public static PackageVersionsPivotSelected = "PackageVersionsPivotSelected";
    public static RecycleBinPackagesPageRequested = "RecycleBinPackagesPageRequested";
    public static RecycleBinPackageVersionsPivotSelected = "RecycleBinPackageVersionsPivotSelected";
    public static RecycleBinPackageVersionRestore = "RecycleBinPackageVersionRestore";
    public static RecycleBinPackageVersionPermanentDelete = "RecycleBinPackageVersionPermanentDelete";
    public static PageLoaded = "PageLoaded";
    public static PageLoadedNoFeeds = "NoFeeds";
    public static PageLoadedNoLicense = "NoLicense";
    public static RemovePackage = "RemovePackage";
    public static RemovePackageDialogClosed = "RemovePackageDialogClosed";
    public static RetentionPoliciesRemoved = "RetentionPoliciesRemoved";
    public static RetentionPoliciesUpdated = "RetentionPoliciesUpdated";
    public static UpstreamEnabledMoreInfoLink = "UpstreamEnabledMoreInfoLink";
    public static UpstreamSourceUpdated = "UpstreamSourceUpdated";
    public static VersionLimitBanner = "VersionLimitBanner";
    public static ViewPanel = "ViewPanel";
    public static ViewPanelLearnMoreClicked = "ViewPanelLearnMoreClicked";
}

export class FeedSettingsCi {
    // details
    public static SaveFeedDetails = "SaveFeedDetails";
    public static DeleteFeed = "DeleteFeed";
    public static ShowDeleteFeedDialog = "ShowDeleteFeedDialog";
    public static PermanentDeleteFeed = "PermanentDeleteFeed";
    public static ShowPermanentDeleteFeedDialog = "ShowPermanentDeleteFeedDialog";
    public static RestoreFeed = "RestoreFeed";
    public static DiscardDialog = "DiscardDialog";

    // permissions
    public static AddPermissions = "AddPermissions";
    public static AddUsersOrGroupsPanel = "AddUsersOrGroupsPanel";
    public static AddScopedBuildPermission = "AddScopedBuildPermission";
    public static DeletePermissions = "DeletePermissions";
    public static ShowDeletePermissionsDialog = "ShowDeletePermissionsDialog";

    // views
    public static AddViews = "AddViews";
    public static AddOrEditViewPanel = "AddOrEditViewPanel";
    public static DeleteViews = "DeleteViews";
    public static SetAsDefaultView = "SetAsDefaultView";
    public static ShowDeleteViewsDialog = "ShowDeleteViewsDialog";

    // upstream
    public static AddUpstreamSources = "AddUpstreamSources";
    public static AddUpstreamSourcesPanel = "AddUpstreamSourcesPanel";
    public static DeleteUpstreamSources = "DeleteUpstreamSources";
    public static ShowDeleteUpstreamSourcesDialog = "ShowDeleteUpstreamSourcesDialog";
    public static ShowUpstreamHealthStatusDialog = "ShowUpstreamHealthStatusDialog";
    public static ReorderUpstreamSources = "ReorderUpstreamSources";

    // general ux
    public static FilterChanged = "FilterChanged";
    public static PivotChanged = "PivotChanged";
}

export class PerformanceConstants {
    public static Area = "Packaging";
    public static DeleteFeed = "PackageHub.DeleteFeed";
    public static PermissionsLoad = "PackageHub.EditPermissions.Load";
    public static PermissionsSave = "PackageHub.EditPermissions.Save";
    public static ReleaseViewsSave = "PackageHub.ReleaseViews.Save";
    public static UpstreamSourcesSave = "PackageHub.UpstreamSources.Save";
}

/**
 * Data provider constants.
 */
export class DataProviderConstants {
    public static PackageByBuildProvider = "ms.feed.package-by-build-provider";
    public static PackageHubDataProvider = "ms.feed.package-hub-data-provider";
    public static FeedMessagesDataProvider = "ms.feed.feed-messages-data-provider";
    public static FeedPackageDependenciesDataProvider = "ms.feed.feed-package-dependencies-data-provider";
    public static FeedPackagesDataProvider = "ms.feed.feed-packages-data-provider";
    public static PackageSizeBreakdownDataProvider = "ms.feed.package-size-breakdown-data-provider";
}

export class IdentityDescriptor {
    public static NamespaceAdministratorsGroup =
        "Microsoft.TeamFoundation.Identity;S-1-9-1551374245-1204400969-2402986413-2179408616-0-0-0-0-1";
    public static EveryoneGroup =
        "Microsoft.TeamFoundation.Identity;S-1-9-1551374245-1204400969-2402986413-2179408616-0-0-0-0-3";
}

export class SettingsConstants {
    public static PackagingSettingsPath = "Packaging";
    public static MruFeedIdPath = "Packaging/MruFeedId";
    public static MruFeedId = "MruFeedId";
}

export class GlobalSettingsTabControlIds {
    public static TAB_CONTROL_ID = "AEFE220D-5518-4A81-978B-A178DFFCF905";
    public static TAB_GROUP_ID = "456F54F5-E1CB-42EA-A011-D11ACE0F163D";
}

export class ConnectToFeedTabControlIds {
    public static TAB_CONTROL_ID = "BEFFCEBB-20CF-4CC0-BA4F-A00EDB1909F8";
    public static TAB_GROUP_ID = "015967F9-E84A-4819-AF7B-4DC3E1A77A0C";
}

export class EditFeedTabControlIds {
    public static TAB_CONTROL_ID = "EE09E31D-038D-482F-BF04-FEE3FF224FC1";
    public static TAB_GROUP_ID = "69A9D53A-A15D-45A1-8C12-03DAE120EC4A";
}

export const PackagingServiceInstanceId: string = "00000030-0000-8888-8000-000000000000";
export const FeedServiceInstanceId: string = "00000036-0000-8888-8000-000000000000";
export const TfsServiceInstanceId: string = "00025394-6065-48ca-87d9-7f5672854ef7";

export class FwLinks {
    public static CreateFeedPageWhatsThis = "https://go.microsoft.com/fwlink/?linkid=859326";
    public static EditFeedDeletedPackagesTabImmutableFeed = "https://go.microsoft.com/fwlink/?linkid=851326";
    public static ConnectToFeedViewWhatsThis = "https://go.microsoft.com/fwlink/?linkid=849453";
    public static ConnectToFeedUpstreamSourcesWhatsThis = "https://go.microsoft.com/fwlink/?linkid=869027";
    public static UpstreamLocatorCommandHeresHow = "https://go.microsoft.com/fwlink/?linkid=2017451";
    public static ViewsDocs = "https://docs.microsoft.com/en-us/azure/devops/artifacts/concepts/views";
    public static UpstreamDocs = "https://go.microsoft.com/fwlink/?linkid=2090231";
    public static ManualUpgradeLearnMore = "https://go.microsoft.com/fwlink/?linkid=874029";
    public static CreateVirtualEnvPyPi = "https://go.microsoft.com/fwlink/?linkid=2015235";
    public static SupportedDistTypesPyPi = "https://go.microsoft.com/fwlink/?linkid=2015238";
    public static DownloadVstsCliTool = "https://go.microsoft.com/fwlink/?linkid=2090408";
    public static DeleteDialogLearnMore = "https://go.microsoft.com/fwlink/?linkid=869883";
    public static DeleteDialogLearnMoreNpm = "https://go.microsoft.com/fwlink/?linkid=2047640";
    public static ViewPermissionDetails = "https://go.microsoft.com/fwlink/?linkid=2130515";
}

export class Exceptions {
    public static FeedNotReleasedException = "FeedNotReleasedException";
    public static FeedNameAlreadyExistsException = "FeedNameAlreadyExistsException";
    public static PackageNotFoundException = "PackageNotFoundException";
}

export class ElementClassConstants {
    public static EditFeedDialogErrorInText = "feed-edit-dialog-error-in-text";
    public static FeedEditDialogLabel = "feed-edit-dialog-label";
}

export class SettingsPivotKeys {
    public static details = "details";
    public static permissions = "permissions";
    public static views = "views";
    public static upstreams = "upstreams";
}

/**
 * Keys for Filter bar item in Settings
 */
export class SettingsFilterItemKey {
    public static views = "views";
    public static userOrGroup = "userOrGroup";
    public static role = "role";
}

/**
 * Keys for error validation
 */
export class FeedSettingsComponents {
    public static feedName = "feedName";
    public static feedRetentionPolicyMaxVersions = "maxVersions";
    public static feedRetentionPolicyDaysToKeep = "daysToKeep";
    public static upstreamSourceName = "upstreamSourceName";
    public static upstreamSourceLocation = "upstreamSourceLocation";

    /**
     * View Name component in Add view panel
     */
    public static viewName = "viewName";

    /**
     * Add user or group in Add user or group dialog
     */
    public static permission = "permission";

    /**
     * Add user or group in viewPanel
     */
    public static viewPermission = "viewPermission";
}

export class PackageDetailsPivot {
    public static readonly OVERVIEW = "overview";
    public static readonly VERSIONS = "versions";
}

export class RecycleBinFilterBarConstants {
    public static readonly KeywordFilterKey = "recycleBinKeyword";
}

export class PackageFilterBarConstants {
    public static readonly KeywordFilterKey = "keyword";
    public static readonly ViewFilterKey = "view";
    public static readonly SourceFilterKey = "source";
}

export const AllIdPrefix = "-all";
export const LatestIdPrefix = "-latest";
export const SingleIdSuffix = "-single";

export class PackageCommandIds {
    public static readonly Delete = "delete";
    public static readonly DeleteAll = PackageCommandIds.Delete + AllIdPrefix;
    public static readonly DeleteLatest = PackageCommandIds.Delete + LatestIdPrefix;
    public static readonly Unpublish = "unpublish";
    public static readonly UnpublishAll = PackageCommandIds.Unpublish + AllIdPrefix;
    public static readonly UnpublishLatest = PackageCommandIds.Unpublish + LatestIdPrefix;
    public static readonly Unlist = "unlist";
    public static readonly UnlistAll = PackageCommandIds.Unlist + AllIdPrefix;
    public static readonly UnlistLatest = PackageCommandIds.Unlist + LatestIdPrefix;
    public static readonly Relist = "relist";
    public static readonly RelistAll = PackageCommandIds.Relist + AllIdPrefix;
    public static readonly RelistLatest = PackageCommandIds.Relist + LatestIdPrefix;
    public static readonly Deprecate = "deprecate";
    public static readonly DeprecateAll = PackageCommandIds.Deprecate + AllIdPrefix;
    public static readonly DeprecateLatest = PackageCommandIds.Deprecate + LatestIdPrefix;
    public static readonly PermanentDelete = "permanentDelete";
    public static readonly RestoreToFeed = "restoreToFeed";
    public static readonly EmptyRecycleBin = "emptyRecycleBin";
    public static readonly CreateBadge = "createBadge" + SingleIdSuffix;
}

export const FEEDSETTINGS_ADDPERMISSION_IDENTITYPICKERSEARCHCONTROL_CONSUMERID = "63A5F1F3-1C07-4F49-A831-F8145F887D2A";
export const FEEDSETTINGS_VIEWS_IDENTITYPICKERSEARCHCONTROL_CONSUMERID = "9D2A13DD-3E2D-46CC-BCFF-0FC54BC09DFB";

export class HubViewDefaultPivots {
    public static readonly feed = "packages";
    public static readonly recycleBin = "recycleBinPackages";
    public static readonly settings = SettingsPivotKeys.details;
}

export class ErrorCi {
    public static PackageHubDataProviderIsEmpty = DataProviderConstants.PackageHubDataProvider + ".IsEmpty";
}
